/**
 * illm-common.js
 * Version: 1.1.0
 * 
 * Update Log:
 * 1.1.0: 2026/01/06 タブ切り替え機能(tabswitch)を追加
 * 1.1.0: 2026/01/06 ヘッダーメニュー展開(toggleHeaderMenu)を追加
 * 1.1.0: 2026/01/06 アコーディオンメニュー(accordionMenu)を追加
 * 
 * Versioning Rule:
 * - 1.0.0 : 初版リリース
 * - 1.1.0 : 機能追加（既存機能への影響なし）
 * - 1.1.1 : バグ修正・微細な調整
 * - 2.0.0 : 大規模な変更・仕様変更（互換性なし）
 */

const illm = { common:{} };

/**
 * PC、スマホのブレークポイント定数
 */
illm.common.breakpoint = {
  minPc: 750,       // 750px以上をPCとする
  maxMobile: 989,   // 989px以下をモバイル（スマホ・タブレット）とする
  maxSp: 749        // 749px以下をスマホとする
};

/**
 * PC判定
 */
illm.common.isPC = function() {
  return window.matchMedia(`(min-width: ${illm.common.breakpoint.minPc}px)`).matches;
};

/**
* SP判定
*/
illm.common.isSmartphone = function() {
 return window.matchMedia(`(max-width: ${illm.common.breakpoint.maxSp}px)`).matches;
};

/**
 * SPとタブレット判定
 */
illm.common.isMobile = function() {
 return window.matchMedia(`(max-width: ${illm.common.breakpoint.maxMobile}px)`).matches;
}

/**
 * 現在のページのURLを取得(絶対パス)
 */
illm.common.getCurrentUrl = function() {
  return `${document.location.protocol}//${document.location.host}${document.location.pathname}`;
};

/**
 * HOMEのURLを取得（pathnameからの絶対パス）
 */
illm.common.getHomeUrlPathName = () => '/';

/**
 * HOMEのURLを取得(絶対パス)
 */
illm.common.getHomeUrl = function() {
  const pathname = illm.common.getHomeUrlPathName();
  return `${document.location.protocol}//${document.location.host}${pathname}`;
};

/**
 * URLからクエリパラメータを取得する関数
 */
illm.common.getQueryParams = function() {
  const params = {};
  const queryString = window.location.search;//クエリパラメータを取得　例：?product_name=シャツ&...
  const urlParams = new URLSearchParams(queryString);

  // 各クエリパラメータをキーと値に分けて、オブジェクトに格納　例：{product_name: 'シャツ', ...}
  for (const [key, value] of urlParams) {
    params[key] = value;
  }
  // オブジェクトを返す
  return params;
}

/**
 * トップページ判定
 */
illm.common.isPageTop = function() {
  return Util.isPageRegex('^/\/?$');
};

/**
 * 現在時刻をサーバーから取得
 */
illm.common.getServerDate = function() {
  const url = window.location.href;
  return fetch( url )
  .then(res => {
    if (!res.ok) throw new Error( 'fetch failed' );
    // レスポンスヘッダーから時刻を取得
    return new Date( res.headers.get('Date') );
  })
  .catch(error => {
    // エラー時はブラウザの現在時刻を返す
    return new Date();
  });
};

/**
 * スムーススクロール
 */
illm.common.smoothScroll = function() {
  // ページ内リンクを全て取得（hrefが#で始まるもの）
  const links = document.querySelectorAll('a[href^="#"]');
  // 各リンクにクリックイベントを追加
  links.forEach(function(link) {
    link.addEventListener('click', function(e) {
      // デフォルトのリンクを防止
      e.preventDefault();
      // href属性からターゲット要素を取得
      // hrefが空や"#"の場合はページトップ（html要素）にスクロール
      const target = document.querySelector(link.getAttribute('href') || 'html');
      if (!target) {
        return; // ターゲットが存在しなければ処理を終了
      }
      // ネイティブのスムーズスクロールを実行
      target.scrollIntoView({ behavior: 'smooth' });
    });
  });
};

/**
* クッキーを設定する関数
*
* @param {string} name - 設定したいクッキーの名前
* @param {string} value - 設定したいクッキーの値
* @param {object} options - オプション
*    options.days      {number} 有効日数（整数）
*    options.expiresMs {number} 有効期限（ミリ秒単位）
*                               例）1時間 = 60 * 60 * 1000
*                               例）10分  = 10 * 60 * 1000
*    options.session   {boolean} trueならセッションCookie
*/
illm.common.setCookie = function(name, value, options) {
  if (options.session) {
    // セッションCookie（ブラウザ閉じたら消える）
    document.cookie = `${name}=${value};path=/`;
    return;
  }

  let expires = "";
  if (options.expiresMs) {
    // ミリ秒指定の場合
    const date = new Date();
    date.setTime(date.getTime() + options.expiresMs);
    expires = "expires=" + date.toUTCString();
  } else if(options.days) {
    // 日数指定の場合
    const date = new Date();// 現在日時を取得
    // 日数をミリ秒に変換
    date.setTime(date.getTime() + (options.days * 24 * 60 * 60 * 1000));
    // Cookie用のexpires文字列を生成（UTC形式で指定）
    expires = "expires=" + date.toUTCString();
  }
  // 有効期限付きで cookie を設定
  document.cookie = `${name}=${value};${expires};path=/`;
};

/**
* クッキーを取得する関数
*
* @param {string} cookieName - 取得したいクッキーの名前
*/
illm.common.getCookie = function(cookieName) {
  const cookiePrefix = cookieName + "=";
  const allCookiesArray = document.cookie.split(';');// すべてのクッキーをセミコロンで分割
  // すべてのクッキーをループでチェック
  for (let i = 0; i < allCookiesArray.length; i++) {
    let cookie = allCookiesArray[i].trim();// 前後のスペースを削除
    // クッキー名が一致するものを探す
    if (cookie.indexOf(cookiePrefix) === 0) {
    // クッキーの値を返す
    return cookie.substring(cookiePrefix.length);
    }
  }
  // クッキーが見つからない場合はnullを返す
  return null;
};

/**
* リサイズ時に画面幅が指定のブレークポイント以下の場合に指定した処理を実行
* 
* @param {number} breakpoint - 判定する幅（例えば、749px以下でスマホ）
* @param {function} callback - 画面幅がブレークポイント以下になった時に実行する処理
*/
illm.common.onResize = function(breakpoint, callback) {
  let isExecuted = false; // 一度だけ実行されたかどうかを示すフラグ

  function checkSize() {
    if (window.innerWidth <= breakpoint) {
      if (!isExecuted) {
        callback();// 初回だけコールバックを実行
        isExecuted = true;// 実行済みに設定
      }
    } else {
      // サイズが大きくなったら再度実行できるようリセット
      isExecuted = false;
    }
  }

  // 初回判定
  checkSize();

  // リサイズ時にもチェック
  window.addEventListener('resize', function() {
    checkSize();
  });
};

/**
* 文字数制限（半角文字は 1 バイト、全角文字は 2 バイト）
* 
* @param {string|HTMLElement|jQuery} target - 対象の input 要素
* @param {number} maxBytes - 最大バイト数
*/
illm.common.enforceByteLimit = function(target, maxBytes) {
  let value = target.value;// 入力値を取得
  let currentBytes = 0; // 現在のバイト数
  let charBytes; // 各文字のバイト数
  let result = ''; // 制限内の文字列

  for(let i=0; i < value.length; i++){
    // 半角か全角かを判定
    if( value.charCodeAt(i) <= 127 ){
      charBytes = 1;
    }else {
      charBytes = 2;
    }
    // 最大バイト数を超えるならそれ以上は追加しない
    if( currentBytes + charBytes > maxBytes ){
      break;
    }
    currentBytes += charBytes;
    result += value[i];
  }
  // 制限以内の文字列だけを再セット
  target.value = result;
};

/**
 * 日付に関する共通関数
 */
illm.common.dateUtil = {
  /**
  * 開始日から指定日数後の終了日を返す
  * @param {Date} startDate - 開始日（Dateオブジェクト）
  * @param {number} periodDays - 開始日からの期間（日数）
  * @returns {Date} 指定日数後の終了日時（その日の23:59:59.999に設定されたDateオブジェクト）
  * 例: start=2025/08/20, days=30 → 2025/09/19 23:59:59.999
  */
  getEndDateByDays: function(startDate, periodDays, inclusive = true) {
    // 開始日から periodDays 日後の日時を作成
    const periodEndDate = new Date(startDate.getTime() + periodDays * 24 * 60 * 60 * 1000);
    // 終了日を含める（その日の23:59:59.999を設定）
    if (inclusive) {
      periodEndDate.setHours(23, 59, 59, 999);
    // 終了日を含めない（翌日の00:00:00.000を設定）
    }else{
      periodEndDate.setHours(0, 0, 0, 0);
      periodEndDate.setDate(periodEndDate.getDate() + 1);
    }
    // 終了日時を返す
    return periodEndDate;
  },

  /**
  * 日付が指定した期間内に含まれるか判定
  * @param {Date} target - 判定対象の日付
  * @param {Date} startDate - 開始日（含む）
  * @param {Date} endDate - 終了日（含む）
  * @param {boolean} inclusiveEnd - 終了日を含むかどうか（デフォルト: true）
  * @returns {boolean} - 期間内なら true、期間外なら false
  */
  isWithinRange: function(targetDate, startDate, endDate, inclusiveEnd = true) {
    // 判定対象の日付をミリ秒に変換
    const targetTimeMs = targetDate.getTime();
    // 開始日をミリ秒に変換
    const startTimeMs = startDate.getTime();
    // 終了日をミリ秒に変換
    const endDateAdjusted = new Date(endDate.getTime());
    if (!inclusiveEnd) {
      // 終了日を含まない場合 → 前日の23:59:59.999
      endDateAdjusted.setDate(endDateAdjusted.getDate() - 1);
    }
    const endTimeMs = endDateAdjusted.getTime();

    // 開始日を含むかどうかで判定
    const isAfterStart = targetTimeMs >= startTimeMs;
    // 終了日を含むかどうかで判定
    const isBeforeEnd = targetTimeMs <= endTimeMs;

    // 両方の条件を満たす場合のみ true を返す
    return isAfterStart && isBeforeEnd;
  }
};

/**
 * タブ切り替え
 */
illm.common.tabswitch = function() {
  const activeClass = 'is-active';//アクティブclass
  // タッチ可能なデバイスかどうか判定
  let isTouchDevice;
  // 古いブラウザやiOS Safari向けの判定 or モダンなブラウザやWindowsタッチパネルPC向けの判定
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    isTouchDevice = true;
  // いずれにも該当しない場合は非タッチデバイス（マウス操作など）
  } else {
    isTouchDevice = false;
  }

  const containers = document.querySelectorAll('.js-tab__container');
  
  containers.forEach(function (container) {
    // data-event属性からイベントを取得（未指定なら click）
    let eventType = container.dataset.event || 'click';

    // スマホ（タッチ端末）では hover を無効化
    if (eventType === 'hover') {
      eventType = isTouchDevice ? 'click' : 'mouseenter';
    }

    // 直近の親コンテナが自分自身である要素のみを抽出（入れ子対策）
    const allButtons = Array.from(container.querySelectorAll('.js-tab__button')).filter(function (button) {
      return button.closest('.js-tab__container') === container;
    });

    const allContents = Array.from(container.querySelectorAll('.js-tab__content')).filter(function (content) {
      return content.closest('.js-tab__container') === container;
    });

    // ボタンのクリックイベント
    allButtons.forEach(function (button, index) {
      button.addEventListener(eventType, function () {
        // すべてのボタンとコンテンツからアクティブクラスを削除
        allButtons.forEach(function (btn) {
          btn.classList.remove(activeClass);
        });
        allContents.forEach(function (content) {
          content.classList.remove(activeClass);
        });

        // 選択された要素にアクティブクラスを付与
        button.classList.add(activeClass);
        const activeContent = allContents[index];
        if (activeContent) {
          activeContent.classList.add(activeClass);

          // アクティブ階層内のSwiperを更新
          const swiperElements = activeContent.querySelectorAll('.swiper');
          // コンテンツ自体がSwiperの場合も含めてチェック
          const allSwipers = activeContent.classList.contains('swiper') 
            ? [activeContent, ...Array.from(swiperElements)] 
            : Array.from(swiperElements);

          allSwipers.forEach(function (element) {
            if (element.swiper) {
              element.swiper.update();
            }
          });
        }
      });
    });
  });
};

/**
 * NEWアイコンの表示制御（発売日から30日以内なら表示）
 * @param date サーバー時間
 * @param periodDays 表示期間（日）
 */
illm.common.newicon = function(date, periodDays) {
  const newBadgePeriodDays = periodDays || 30; // アイコンの表示期間（引数が空の場合はデフォルト値は30日）
  const hiddenClass = 'hidden';//非表示class名
  const nowDate = date;//現在日時
  const releaseDateElements = document.querySelectorAll('[data-release-date]');
  const endDateElements = document.querySelectorAll('[data-end-date]');
  const newIcons = document.querySelectorAll('.js-new-icon');

  if (releaseDateElements.length > 0) {
    // メタフィールドが発売日の場合
    newIcons.forEach(function(element) {
      // 発売日を取得（datasetを使用してdata-release-dateを取得）
      const releaseDate = new Date(element.dataset.releaseDate);// 例：{releaseDate: '2025-12-31'}
      
      // 無効な日付ならスキップ
      if(isNaN(releaseDate.getTime())){
        return;
      }
      
      // 発売日の開始時刻を 0:00:00.000 に設定
      releaseDate.setHours(0, 0, 0, 0);

      // 表示終了日時 = 発売日からnewBadgePeriodDays日後の23:59:59.999
      const displayEndDate = illm.common.dateUtil.getEndDateByDays(releaseDate, newBadgePeriodDays);

      // 現在時刻が表示期間内ならアイコンを表示
      if (illm.common.dateUtil.isWithinRange(nowDate, releaseDate, displayEndDate)) {
        element.classList.remove(hiddenClass);
      }
    });
  }else if(endDateElements.length > 0){
    // メタフィールドが期限日の場合
    newIcons.forEach(function(element) {
      // 表示期限日を取得
      const newEndDate = new Date(element.dataset.endDate);// 例：{newDays: '2025-12-31'}

      // 無効な日付ならスキップ
      if(isNaN(newEndDate.getTime())){
        return;
      }

      newEndDate.setHours(23, 59, 59, 999); // 表示期限は23時59分59秒999ミリ秒まで
      const newEndDateTime = newEndDate.getTime();//UNIX時間に変換
      
      //期限日以内であれば、NEWアイコンを表示
      if(nowDate <= newEndDateTime){
        element.classList.remove(hiddenClass);
      }
    });
  }
};

/**
 * メニュー展開
 */
illm.common.toggleHeaderMenu = function() {
  const openClass = 'is-open';//アクティブクラス
  const menuButtons = document.querySelectorAll('.js-menu-button');//メニュー展開するボタン
  
  menuButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      // 最も近い親のコンテナを探してクラスを切り替え
      const container = button.closest('.js-menu-container');
      if (container) {
        container.classList.toggle(openClass);
      }
    });
  });
}

/**
 * アコーディオンメニュー
 */
illm.common.accordionMenu = function () {
  // アコーディオンのトリガーとなるボタンをすべて取得
  const buttons = document.querySelectorAll('.js-accordion-button');

  /**
   * 処理を実行すべきデバイス条件かどうかを判定する関数
   * @param {HTMLElement} target - 判定対象のボタン要素
   * @returns {boolean} - 実行してよい場合はtrue
   */
  function shouldProcess(target) {
    // ボタンが持っている「限定条件クラス」を確認
    const isSpButton = target.classList.contains('js-accordion-button--sp');
    const isMobileButton = target.classList.contains('js-accordion-button--mobile');

    // スマホ専用設定の場合：現在のデバイスがスマホなら実行
    const isSP = isSpButton && illm.common.isSmartphone();
    
    // モバイル専用設定の場合：現在のデバイスがスマホまたはタブレットなら実行
    const isMobile = isMobileButton && illm.common.isMobile();
    
    // 特にクラス指定がない場合：すべてのデバイスで実行
    const isDefault = !isSpButton && !isMobileButton;

    // いずれかの条件に合致すれば「このボタンは動かしてOK」と判断
    return isSP || isMobile || isDefault;
  }

  /**
   * コンテンツの表示・非表示の切り替え（スライド版）
   * @param {HTMLElement} button - クリックされたボタン要素
   */
  function toggleContent(button) {
    const parent = button.parentElement;
    // .js-accordion-contents を取得
    const content = parent.querySelector('.js-accordion-contents');
    
    if (!content) return;

    // ボタンに is-open がついているか（今から開くのか閉じるのか）で判定
    if (button.classList.contains('is-open')) {
      // 開く：隠れている要素の高さ（scrollHeight）をセット
      content.style.height = content.scrollHeight + 'px';
      
      // アニメーション完了後に高さを auto に戻す（レスポンシブ対応）
      content.addEventListener('transitionend', function handler() {
        if (button.classList.contains('is-open')) {
          content.style.height = 'auto';
        }
        content.removeEventListener('transitionend', handler);
      }, { once: true });
      
    } else {
      // 閉じる：現在の高さを一度数値で固定してから 0 にする
      content.style.height = content.scrollHeight + 'px';
      content.offsetHeight; // リフロー（現在の高さをブラウザに再認識させる）
      content.style.height = '0px';
    }
  }

  // 【初期化処理】ページを読み込んだ時点で、既に「開く」指示があるものを開く
  buttons.forEach(function (button) {
    // 実行条件を満たしており、かつ最初から開くクラス（is-open）がついている場合
    if (shouldProcess(button) && button.classList.contains('is-open')) {
      toggleContent(button);
    }
  });

  // クリックされたら
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      // その時のデバイス環境で動かしてよいボタンであれば実行
      if (shouldProcess(button)) {
        // ボタン自身の見た目を変えるためのクラスを付け外し
        button.classList.toggle('is-open');
        // コンテンツを開閉
        toggleContent(button);
      }
    });
  });
};